<header class="topbar">
  <div class="container d-flex justify-content-between align-items-center">
    <!-- Dropdown Pays -->
    <div class="dropdown" id="dropdownPays">
      <button class="btn country dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <img src="images/drapeau.png" height="20"> Sénégal
      </button>
      <ul class="dropdown-menu">
        <li><a class="dropdown-item" href="#">  <img src="images/drapeau.png" height="20"> Sénégal</a></li>
        <li><a class="dropdown-item" href="#">Côte d'Ivoire</a></li>
        <li><a class="dropdown-item" href="#">Mali</a></li>
      </ul>
    </div>

    <!-- Logo au milieu -->
    <div class="logo text-center">
      <div>
        <img class="img" src="images/bbs.png">
      </div>
    </div>

    <!-- Dropdown Langue -->
    <div class="dropdown" id="dropdownLangue">
      <button class="btn lang dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        FR
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        <li><a class="dropdown-item" href="#">FR</a></li>
        <li><a class="dropdown-item" href="#">EN</a></li>
        <li><a class="dropdown-item" href="#">PT</a></li>
      </ul>
    </div>
  </div>
</header>

<main class="container my-5">
  <div class="row gy-4">
    @if(loading){
      <div class="text-center">
        <div class="spinner-border"></div>
      </div>
    } @else {
      <!-- Partie Commande - En haut sur mobile, à droite sur desktop -->
      <div class="col-lg-5 col-12  order-lg-2 order-xs-1">
        <div class="card-summary mb-2">
          <h3 style="font-weight:600">Montant de la commande</h3>
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="sum-amount text-gradient">{{getMontant()}}</div>
            <div class="text-gradient" style="font-weight:800">FCFA</div>
          </div>
        </div>
      </div>

      <!-- Partie Paiement - En bas sur mobile, à gauche sur desktop -->
      <div class="col-lg-7 col-12 order-lg-1 order-xs-2">
        @if(service==true){
          <div class="row gy-4">
            <div class="col-12 text-center mb-2">
              <h3>Choisir le mode de paiement</h3>
            </div>
            <!-- Payment buttons -->
            <div class="col-6">
              <button (click)="chooseService('snwave')" class="payment-method w-100 border-0" style="background:#49D2FA;color: #fff;">
                <div class="icon" style="background:transparent">
                  <img class="img" src="images/wave.png">
                </div>
                <div style="font-weight:600">Wave</div>
              </button>
            </div>
            <div class="col-6">
              <button (click)="chooseService('snom')" class="btn payment-method w-100 border-0" style="background:#111820;color:#fff">
                <div class="icon" style="background:transparent">
                  <img class="img" src="images/orange.png">
                </div>
                <div style="font-weight:600">Orange Money</div>
              </button>
            </div>
          </div>
        } @else {
          <div style="display: flex;flex-direction: column;justify-content: center;width: 100%;">
            <div style="margin-bottom: 1.3em;">
              @if(choosen_service=='snom'){
                <button class="btn payment-method w-100 border-0" style="background:#111820;color:#fff">
                  <div class="icon" style="background:transparent">
                    <img class="img" src="images/orange.png">
                  </div>
                  <div style="font-weight:600">Orange Money</div>
                </button>
              } @else if(choosen_service=='snwave'){
                <button (click)="chooseService('snwave')" class="payment-method w-100 border-0" style="background:#49D2FA;color: #fff;">
                  <div class="icon" style="background:transparent">
                    <img class="img" src="images/wave.png">
                  </div>
                  <div style="font-weight:600">Wave</div>
                </button>
              } @else {
                <div>Veuillez choisir un service</div>
              }
            </div>
            <div>
              <form [formGroup]="payform">
                <div>
                  <div class="mb-3">
                    <div class="form-group">
                      <input type="text" class="form-control" placeholder="Nom" formControlName="nom">
                      <i class="fa-solid fa-user"></i>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="input-group mb-3">
                    <div class="col-auto">
                      <select class="form-select" id="inputGroupSelect">
                        <option selected><img src="images/drapeau.png" height="10">+221</option>
                      </select>
                    </div>
                    <input formControlName="telephone" type="tel" class="form-control" placeholder="Téléphone">
                  </div>
                </div>
                @if(choosen_service=='snom'){
                  <div>
                    <div class="mb-3">
                      <div class="form-group">
                        <input formControlName="otp" type="text" class="form-control" placeholder="Otp (#144#391*votre_mot_de_passe#)">
                      </div>
                    </div>
                  </div>
                }
              </form>
            </div>
            <div style="display: flex;justify-content: space-between;margin-top: 1.5em;">
              <div>
                <button (click)="validerPaiement()" [disabled]="!payform.valid || load" class="btn payment-method w-100 border-0" style="background:#111820;color:#fff">{{validerButton}}</button>
              </div>
              <div>
                <button class="btn payment-method w-100 border-0" style="background:#111820;color:#fff" (click)="retour()">Retour</button>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</main>
